<template>
  <div>
    <!-- <van-nav-bar
      class="vanBar rq__nav"
      :class="isWhite ? 'varBarBlack' : ''"
      :title="title"
      fixed
      :border="false"
      :left-arrow="isShowBack"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    >
      <template #left>
        <div class="__left">
          <div v-if="isShowSlider">
            <div
              v-if="!userInfo.userAvatar"
              class="__avatar"
            >
              <van-icon
                size="18"
                class-prefix="iconfont icon-user_home_left"
              />
            </div>
            <div
              v-else
              class="__avatar"
            >
              <img
                fit="cover"
                :src="userInfo.userAvatar"
              />
            </div>
          </div>
          <div v-else>
            <div
              class="myIconList"
              v-if="!isNotHistory"
            >
              <van-icon
                class="myIcon"
                :class="isRotate ? 'iconLeftRotate' : ''"
                class-prefix="iconfont  icon-fanhui"
              />
            </div>
            <div
              class="barIcon"
              v-else
            >
              <van-icon
                class="homeIcon"
                class-prefix="iconfont  icon-huidaozhuye-"
              />
            </div>
          </div>
        </div>
      </template>
      <template #title>
        <div class="__title -tab">
          <div class="__item">
            <p class="-activity">活动</p>
            <van-icon class-prefix="iconfont icon-huxian -icon" />
          </div>
        </div>
      </template>
      <template #right>
        <div class="flexBtn">
          <div
            class="myIconList"
            v-if="showRightForward"
            @click.stop="toForward"
          >
            <van-icon
              class="myIcon"
              class-prefix="iconfont icon-fenxiangzhuanfafasongzhijiantouyuanxingshar "
            />
          </div>
          <div
            class="myIconList"
            v-if="showCreate"
            @click.stop="toCreateActivity"
          >
            <van-icon
              class="myIcon"
              name="plus"
            />
          </div>
          <div
            class="myIconList"
            v-if="showMore"
            @click.stop="toShowMore"
          >
            <van-icon
              class="myIcon"
              class-prefix="iconfont icon-gengduo1 "
            />
          </div>
          <div class="myIconList">
            <van-icon
              class="myIcon"
              class-prefix="iconfont icon-Shapecopy"
            />
          </div>
        </div>
      </template>
    </van-nav-bar> -->

    <van-popup
      v-model="isShowNavRight"
      :position="isNavRight ? 'right' : 'left'"
      style="width: 70%; height: 100%"
    >
      <div
        class="navRightWrap"
        :class="isNavRight ? 'myNavRightWrapR' : 'myNavRightWrapL'"
        v-show="isShowNavRight"
      >
        <div
          class="navPeopleTop"
          @click.stop="toMine"
        >
          <div class="peopleWrap">
            <div class="disBew">
              <div class="imgPeople">
                <van-image
                  class="imgWrap"
                  v-if="userInfo.userAvatar"
                  round
                  fit="cover"
                  :src="imageUrlBase150(userInfo.userAvatar)"
                />
              </div>
              <div class="textPeople">
                <div class="name">{{ userInfo.userNickname }}</div>
                <div class="job">
                  @{{ userInfo.userCode ? userInfo.userCode : "暂无入圈号" }}
                </div>
              </div>
            </div>
          </div>
          <div class="peopleTag">
            <div
              class="list"
              @click.stop="toFollow(0)"
            >
              <div class="num">{{ formatNumber(userInfo.followCount) }}</div>
              <div class="text">关注</div>
            </div>
            <div
              class="list"
              @click.stop="toFollow(1)"
            >
              <div class="num">
                {{ formatNumber(userInfo.followbyCount) }}
              </div>
              <div class="text">粉丝</div>
            </div>
            <div
              class="list"
              @click.stop="toOtherPage('/interactMessage')"
            >
              <div class="num">{{ formatNumber(userInfo.praisedSum) }}</div>
              <div class="text">被赞</div>
            </div>
          </div>
        </div>

        <div class="navRightDetail">
          <div
            class="navList"
            @click="toOtherPage('/mySubscribe')"
          >
            <van-icon class-prefix="iconfont icon-icon-xiaoxi1" />
            <span>预定的活动</span>
          </div>
          <div
            class="navList"
            @click="toFollowCLub()"
          >
            <van-icon class-prefix="iconfont icon-quanzi2" />
            <span>圈子和主题</span>
          </div>
          <div
            class="navList"
            @click="toOtherPage('/myComment')"
          >
            <van-icon class-prefix="iconfont icon-huati " />
            <span>帖子和评论</span>
          </div>
          <div
            class="navList"
            @click="toOtherPage('/myLike')"
          >
            <van-icon class-prefix="iconfont icon-dianzanqian " />
            <span>我点赞过的</span>
          </div>
          <div
            class="navList"
            @click="toOtherPage('/myCollect')"
          >
            <van-icon class-prefix="iconfont icon-shoucang " />
            <span>收藏和足迹</span>
          </div>
          <div class="barLine"></div>
          <!-- @click="changeBlack" -->
          <div
            class="navList myFLexBetWeen"
            @click="changeBlack"
          >
            <div>
              <van-icon class-prefix="iconfont icon-yueliang" />
              <span>暗黑模式</span>
            </div>
            <!-- @click="changeBlack"  -->
            <van-switch
              v-model="isBlackModel"
              disabled
              class="mySwitch"
              active-color="#49E6DA"
            />
          </div>
          <div
            class="navList"
            @click="toOtherPage('/toolIndex')"
          >
            <van-icon class-prefix="iconfont icon-shezhi " />
            <span>设置和隐私</span>
          </div>
        </div>

        <div class="navflexWrap">
          <div class="list noList">
            <van-icon
              class="myIcon"
              class-prefix="iconfont icon-sao"
            />
            <span>扫一扫</span>
          </div>
          <div class="list noList">
            <van-icon
              class="myIcon"
              class-prefix="iconfont icon-qrcode"
            />
            <span>二维码</span>
          </div>
        </div>
      </div>
      <!-- </v-touch> -->
      <!-- </transition> -->
    </van-popup>
  </div>
</template>

<script>
import { userInfo, userPhoneBound } from "@/api/user";
import { isApp, navigatorTo, navigatorUserDetailPage } from "@/utils/jsbridge";
import {
  getMyUserInfo,
  checkLoginSync,
  setUserInfo,
  setToken,
  naviagtorPushLogin,
} from "@/utils/auth";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "@/utils/local-storage";

export default {
  name: "navBar",
  props: {
    title: {
      default: "",
    },

    isShowSlider: {
      default: false,
    },
    isCustomTitle: {
      default: false,
    },

    fatherMethod: {
      type: Function,
      default: null,
    },
    isNavRight: {
      default: true,
    },
    isRotate: {
      default: false,
    },
    showMore: {
      default: false,
    },
    isShowBar: {
      default: true,
    },

    isWhite: {
      default: false,
    },
    showCreate: {
      default: false,
    },
    isShowBack: {
      default: true,
    },
    showRightForward: {
      default: false,
    },
    isShowMore: {
      default: true,
    },
    leftText: {
      default: "返回", //这样可以指定默认的值
    },
  },
  data() {
    return {
      isBlackModel: false,
      isShowNavRight: false,
      userInfo: {
        userAvatar:
          "https://ruquan-1305384340.picsh.myqcloud.com/5d4b3a41fd214891b4b6d4a1f6d30398.jpeg",
        userNickname: "点我登录",
      },
      isNotHistory: false,
    };
  },
  mounted() {
    window.jsBridgeCallBack = this.jsBridgeCallBack;

    if (window.history.length <= 1 || window.history.state == null) {
      this.isNotHistory = true;
    } else {
      this.isNotHistory = false;
    }
    if (window.localStorage.getItem("isBlackModel") == "true") {
      this.isBlackModel = true;
    } else {
      this.isBlackModel = false;
    }
  },
  methods: {
    toForward() {
      if (this.fatherMethod) {
        this.fatherMethod();
      } else {
        this.$emit("showShareSheet");
      }
    },
    toShowMore() {
      this.$emit("showMoreSheet");
    },
    followPage() {
      this.isShowNavRight = false;
      this.$router.push({
        path: "/myFollow",
        query: { id: this.userInfo.userUuid },
      });
    },
    toFollow(type) {
      this.isShowNavRight = false;
      this.$router.push({
        path: "/myFollow",
        query: { id: this.userInfo.userUuid, type: type },
      });
    },
    toFollowCLub(type) {
      this.isShowNavRight = false;
      if (checkLoginSync()) {
        this.$router.push({
          path: "/myFollowClub",
          query: { id: this.userInfo.userUuid, type: type },
        });
      } else {
        // 检测路由跳转，是走iOS app登录，还是h5登录
        naviagtorPushLogin();
      }
    },
    changeBlack(e) {
      this.isBlackModel = !this.isBlackModel;
      setLocalStorage("isBlackModel", this.isBlackModel);
      if (this.isBlackModel) {
        window.document.documentElement.setAttribute("theme", "dark-mode");
      } else {
        window.document.documentElement.setAttribute("theme", "light-mode");
      }
    },
    toOtherPage(data) {
      this.isShowNavRight = false;
      if (this.$router.history.current.path == data) {
        // this.isShowNavRight = false;
      } else {
        this.$router.push(data);
      }
    },

    closeNavRight() {
      this.isShowNavRight = false;
    },

    onClickLeft() {
      if (this.isShowSlider) {
        this.isShowNavRight = true;
      } else {
        if (window.history.length <= 1 || window.history.state == null) {
          this.$router.push("/");
        } else {
          this.$router.go(-1);
        }
      }
    },
    // toEditMine() {
    //   if (this.$router.history.current.path == "/editMine") {
    //     this.isShowNavRight = false;
    //   } else {
    //     this.$router.push({ path: "/editMine" });
    //   }
    // },
    toMine() {
      this.isShowNavRight = false;
      if (checkLoginSync()) {
        if (this.$router.history.current.path == "/userDetail") {
        } else {
          let uid = JSON.parse(localStorage.getItem("userInfo")).userUuid;
          navigatorUserDetailPage(uid, () => {
            this.$router.push({
              path: "/userDetail",
              query: {
                userUuid: uid,
              },
            });
          });
        }
      } else {
        // 检测路由跳转，是走iOS app登录，还是h5登录
        naviagtorPushLogin();
      }
    },

    getUserInfo(userUuid) {
      userInfo({ userUuid: userUuid }).then((res) => {
        this.userInfo = res.data;
      });
    },

    // toCreateActivity() {
    //   if (this.$router.history.current.path == "/activityCreate") {
    //     this.isShowNavRight = false;
    //   } else {
    //     this.$router.push({ path: "/activityCreate" });
    //   }
    // },

    onClickRight() {
      if (this.isShowMore) {
        if (checkLoginSync()) {
          var myUserInfo = getMyUserInfo();
          this.getUserInfo(myUserInfo.userUuid);
          return;
        }
      }
    },

    async getUserPhoneBound() {
      let res = await userPhoneBound({});
      if (res.errcode == "0") {
        this.tobackPage();
      }
    },

    tobackPage() {
      if (getLocalStorage("login-redirect")) {
        var redirect = getLocalStorage("login-redirect");
        window.location.replace(
          process.env.FRONT_URL + (redirect || "/circleList")
        );
        removeLocalStorage("login-redirect");
      } else {
        window.location.replace(process.env.FRONT_URL);
      }
    },

    jsBridgeCallBack(callBackData) {
      let aData = JSON.parse(callBackData);
      if (aData.method == "login") {
        setUserInfo(aData.data.userVO);
        setToken(aData.data.token);
        setLocalStorage("imToken", aData.data.imToken);
        this.getUserPhoneBound();
      }

      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
.vanBar {
  .van-nav-bar__text {
    color: #202020;
  }
  .van-nav-bar__content {
  }
  .van-nav-bar__title {
    max-width: 70%;
    color: #202020;
    font-size: px(24);
    /* line-height: px(46); */
  }
  .van-icon {
    font-size: px(24);
    color: #202020 !important;
  }
}
</style>

<style lang="scss" scoped>
.noList {
  color: #ddd !important;
}
.rq__nav {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: px(64);
  background: #f6f6ff;
  z-index: 2;
  // 导航栏左侧
  .__left {
    display: flex;
    flex-direction: row;
    .__avatar {
      width: px(36);
      height: px(36);
      border-radius: px(18);
      img {
        width: 100%;
        height: 100%;
      }
    }
    .__icon {
    }
  }
  // 标题
  .__title {
    width: px(350);
    flex: 1;
  }

  // 导航栏右侧
  .__right {
  }

  .-tab {
    position: relative;
    display: flex;
    justify-content: flex-start;
    .__item {
      position: relative;
      .-icon {
        position: absolute;
        @include gradientColorText(left, #00c2c2, #49e6da) font-size: px(60);
        /* bottom: px(-50); */
      }
      .-activity {
        color: rgba(32, 32, 32, 100);
        font-size: px(28);
        font-family: PingFangSC-Semibold;
      }
      line-height: px(25);
      padding: 0 px(20);
      color: rgba(153, 153, 153, 100);
      font-size: px(20);
    }
  }
}

.navRightWrap {
  width: 100%;
  min-height: 100vh;
  height: 100%;
  background-color: #fff;
  position: fixed;
  top: 0;
  .navPeopleTop {
    padding-left: px(30);
    padding-right: px(50);
    margin: px(30) 0;
    background-color: #fff;
    .peopleWrap {
      display: flex;
      justify-content: space-between;
      padding-top: px(10);
      .disBew {
        display: flex;
        flex: 1;
      }
      .imgPeople {
        width: px(50);
        height: px(50);
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .textPeople {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin: 0 px(10);
        .name {
          display: flex;
          align-items: flex-end;
          color: #202020;
          font-size: px(20);
          span {
            color: rgba(71, 145, 242, 100);
            font-size: px(14);
            margin-left: px(6);
          }
        }
        .job {
          color: #999;
          font-size: px(14);
        }
      }
      .rightPeople {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .editBut {
          width: px(94);
          height: px(40);
          border-radius: px(50);
          color: #fff;
          background-color: #00c2c2;
          font-size: px(16);
          text-align: center;
          line-height: px(40);
          border: 1px solid #00c2c2;
        }
        .mineBut {
          color: rgba(84, 84, 84, 100);
          font-size: px(14);
          display: flex;
          justify-content: flex-end;
          img {
            width: px(22);
          }
        }
      }
    }
    .peopleTag {
      margin-top: px(30);
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      .list {
        text-align: center;
        .num {
          color: rgba(32, 32, 32, 100);
          font-size: px(22);
        }
        .text {
          margin-top: px(10);
          color: rgba(153, 153, 153, 100);
          font-size: px(14);
        }
      }
    }
  }
  .navflexWrap {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 px(30);
    height: px(60);
    background-color: #f6f6ff;
    .list {
      display: flex;
      align-items: center;
      color: #202020;
      span {
        font-size: px(16);
        margin-left: px(5);
      }
      .myIcon {
        font-size: px(24);
      }
    }
  }
  .navClose {
    padding-top: px(20);
    .van-icon {
      font-size: px(20);
      /* font-weight: 600; */
      color: #545454;
    }
  }
  .navRightDetail {
    padding: 0 px(30);
    margin-top: px(30);
    color: #545454;
    .barLine {
      width: 100%;
      height: px(1);
      background-color: #d8d8d8;
      margin-bottom: px(30);
    }
    .navList {
      color: #545454;
      display: flex;
      align-items: center;
      font-size: px(18);
      /* line-height: px(46); */
      margin-bottom: px(30);
      span {
        margin-left: px(15);
      }
      .iconfont {
        font-size: px(20);
      }
      .mySwitch {
        font-size: px(20);
      }
    }
  }
}

.navWrap {
  /* padding-top: px(20); */
  .myIcon {
    font-size: px(24);
    margin-right: px(15);
  }
  .vanBar {
    z-index: 999;
    background-color: #f6f6ff;
    /* height: px(46); */
  }
  .varBarBlack {
    background-color: #f6f6ff;
  }
  .navRightModel {
    width: 100vw;
    min-height: 100vh;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }
  .myNavRightWrapL {
    left: 0;
  }
  .myNavRightWrapR {
    right: 0;
  }
  /* 侧边栏UI */

  .topMore {
    width: 20px;
  }
  /* .leftIcon {
    width: 22px;
    margin-right: 20px;
  } */
  .flexBtn {
    display: flex;
    align-items: center;
    .myIconList {
      display: flex;
    }
    .icon-icon {
      font-size: px(30);
    }
    .iconWrap {
      display: flex;
      align-items: center;
      .myIconList {
        margin-left: px(10);
        .myIcon {
          font-size: px(25);
          color: #000;
        }
      }
      .iconfont {
        color: rgba(0, 0, 0, 1);
        font-size: px(25);
      }
      .van-icon-arrow-left {
        color: rgba(0, 0, 0, 1);
        font-size: px(28);
      }
    }
  }
  .barIcon {
    width: px(36);
    height: px(36);
    border-radius: 100%;
    background-color: #bbbbbb;

    .homeIcon {
      font-size: px(18);
      color: #000;
      line-height: px(36);
    }
  }
}
</style>



// WEBPACK FOOTER //
// navBar.vue?631a6034